import React from 'react';
import Select from '../Select';
import { useSubRegion } from 'modules/soato/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  label: string;
  regionId: number;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onChange?: () => void;
}

const SubRegion: React.FC<Props> = ({ name, label, onChange, regionId, required, placeholder, disabled, ...props }) => {
  const {
    i18n: { language }
  } = useTranslation();

  const { data, isLoading } = useSubRegion({ region_id: regionId });

  return (
    <Select
      name={name}
      label={label}
      options={data}
      optionValue={'id'}
      optionLabel={option => option.name[language]}
      required={required}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      isLoading={isLoading}
      {...props}
    />
  );
};

export default SubRegion;
